// Service for employee lookup operations (lightweight endpoint for filters/selectors)
import { apiClient, API_CONFIG } from '../../../core';
import type { ApiResponse } from '../../../shared';
import { buildRequiredQueryString } from '../../../shared';
import type {
  LC_GetEmployeeLookupIn,
  LC_GetEmployeeLookupOut,
} from '../types';


export class EmployeeLookupService {
  /**
   * Lightweight lookup of employees for filters/selectors
   * Returns only ID, name, and RUT
   */
  async lookup(params: LC_GetEmployeeLookupIn): Promise<ApiResponse<LC_GetEmployeeLookupOut>> {
    const queryString = buildRequiredQueryString({ ...params }, ['status']);
    const endpoint = `${API_CONFIG.ENDPOINTS.EMPLOYEES.LOOKUP}${queryString}`;
    
    return apiClient.get<LC_GetEmployeeLookupOut>(endpoint);
  }
}

export const employeeLookupService = new EmployeeLookupService();
